(function($, Drupal) {
  Drupal.behaviors.inpave_nav = {
    attach: function(context, settings) {
      let $inpage_toggle_trigger,
          $inpage_toggle_trigger_vue,
          $inpage_nav_wrapper;

      $inpage_toggle_trigger = $('#inpage-nav-toggle');
      $inpage_toggle_trigger_vue = $('#inpage-nav-toggle-vue');
      $inpage_nav_wrapper = $('.region-inpage-nav');

      function toggle_side_nav(toggle) {
        toggle.toggleClass('expanded');

        if (toggle.hasClass('expanded')) {
          toggle.attr('aria-expanded', true);
          $inpage_nav_wrapper.addClass('expanded');
        }
        else {
          toggle.attr('aria-expanded', false);
          $inpage_nav_wrapper.removeClass('expanded');
        }
      }

      $inpage_toggle_trigger.once('toggle-inpage').on('click', function() {
        toggle_side_nav($(this));
      });

      $inpage_toggle_trigger_vue.once('toggle-inpage-vue').on('click', function() {
        toggle_side_nav($(this));
      });
    }
  };
})(jQuery, Drupal);
